import { ActionIcon, Tooltip } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import * as React from 'react';
import { OpenModal } from '../../../../../react-commons/utils/modals/openModal';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { DetailedValidationResource } from '../../../resource/resources/validation/detailedValidationResource';
import { TOOLTIPS } from '../../../resource/tooltipTexts';
import { ResourceDetailsDialogContent } from '../dialogs/validation/ResourceDetailsDialogContent';
import { Show } from '../../../../../react-commons/components/control-flow/Show';
import { useParams } from 'react-router-dom';
import { useUserId } from '../../authentication/useUserId';
import { useUserActions } from '../../../resource/resources/persistables/user/userResource';

export const ResourceDetailsButton= ({ resourceType, resourceValidationResult, style }: {
    resourceValidationResult?: DetailedValidationResource;
    resourceType: ResourceType | ResourceType[];
    style?: React.CSSProperties;
}) => {
    const userId = useUserId('');
    const { id: projectId } = useParams<{ id: string }>();

    const userActions = useUserActions();
    const userSystemRights = userActions.useGetUserEffectiveRightsOfUser(userId, projectId);
    const isProcessAdmin =
        userSystemRights.data?.isProcessAdmin;

    const openValidationDialog = () => {
        OpenModal.ContentModal({
            title: 'Resource Details',
            content: <ResourceDetailsDialogContent resourceValidation={resourceValidationResult}
                                                   resourceType={resourceType} />,
        });
    };

    return (
        <Show when={isProcessAdmin}>
            <Tooltip label={TOOLTIPS.VALIDATION_RESULT}>
                <ActionIcon
                    size={'sm'}
                    style={{ padding: '6px', backgroundColor: 'inherit', ...style }}
                    variant={'transparent'}
                    onClick={openValidationDialog}
                >
                    <IconExclamationCircle
                        color={
                            resourceValidationResult?.maxSeverity === 'FATAL' ? 'error'
                                : resourceValidationResult?.maxSeverity === 'CRITICAL' ?
                                    'var(--mantine-color-error)'
                                    : resourceValidationResult?.maxSeverity === 'WARNING' ?
                                        'var(--mantine-color-warning)'
                                        : resourceValidationResult?.maxSeverity === 'NOTE' ?
                                            'var(--mantine-color-info)'
                                            : 'var(--mantine-color-base-button)'
                        }
                    />
                </ActionIcon>
            </Tooltip>
        </Show>
    );
};


